import { Typography } from '@mui/material'
import BoxWithBackground from '../../atoms/container/BoxWithBackground'
import RowStack from '../../atoms/container/RowStack'
import colors from 'styles/colors'
import StarRoundedIcon from '@mui/icons-material/StarRounded'
import StarHalfRoundedIcon from '@mui/icons-material/StarHalfRounded'
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded'
import { useTranslation } from 'react-i18next'

const RolePlayScore = ({ score = 0, containerSx = {} }) => {
  const { t } = useTranslation()
  const textSx = {
    color: colors.MidnightTeal400,
    fontFamily: 'Poppins'
  }
  const totalStars = 5
  const parsedScore = parseFloat(score ?? 0)
  const scoreOutOfFive = (parsedScore / 100) * totalStars

  // Calculate full, half, and empty stars
  const fullStars = Math.floor(scoreOutOfFive)
  const halfStar = scoreOutOfFive - fullStars >= 0.5 ? 1 : 0
  const emptyStars = totalStars - fullStars - halfStar

  return (
    <>
      <BoxWithBackground
        sx={{
          padding: '12px 16px 8px 16px',
          minWidth: 160,
          backgroundColor: colors.MutedTeal50,
          borderRadius: 20,
          position: 'relative',
          ...containerSx
        }}>
        <RowStack
          spacing={0}
          width={'auto'}
          alignItems={'flex-start'}
          sx={{ position: 'absolute', left: 22, top: -12 }}>
          {/* Display full stars */}
          {Array(fullStars)
            .fill()
            .map((_, index) => (
              <StarRoundedIcon
                key={index}
                style={{ color: colors.GoldenYellow400 }}
              />
            ))}
          {/* Display half star if needed */}
          {halfStar === 1 && (
            <StarHalfRoundedIcon style={{ color: colors.GoldenYellow400 }} />
          )}
          {/* Display empty stars */}
          {Array(emptyStars)
            .fill()
            .map((_, index) => (
              <StarBorderRoundedIcon
                key={index + fullStars + 1}
                style={{ color: colors.GoldenYellow400 }}
              />
            ))}
          {/* Display score */}
        </RowStack>
        <RowStack spacing={2} justifyContent={'center'}>
          <Typography variant='h5' sx={textSx}>
            {t('stepQuiz.score')}:
          </Typography>
          <Typography variant='h2' sx={textSx}>
            {parsedScore.toFixed(0)}
          </Typography>
          <Typography variant='h5' sx={textSx}>
            / 100
          </Typography>
        </RowStack>
      </BoxWithBackground>
    </>
  )
}

export default RolePlayScore
